import { Button, Col, Form, Input, notification, Row, Select, Table } from "antd";
import SlipModalComponent from "components/SlipModalComponent";
import { THUE_SUAT } from "constants";
import { DOCUMENT_TYPE_ID } from "constants";
import { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNhapKhoCTByManx } from "store/slices/sale/nhapkhoSlice";
import { copyPhieuNhapThueSangNoiBo } from "store/slices/sale/nhapxuatSlice";
import Utils from "utils";

const ModelCopyPhieuNhap = ({
    isVisibleCopy,
    setIsVisibleCopy,
    record
}) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { dmKkList } = useSelector((state) => state.danhMucSale);

    const { nhapKhoCTList } = useSelector((state) => state.nhapKhoSale);
    const childRef = useRef(null);

    useEffect(() => {
        dispatch(
            getNhapKhoCTByManx({
                manx: record?.manx,
                isNewCt: false,
            })
        );

        form.setFieldValue("ghichu", record?.ghichu)

    }, [dispatch, form, record])

    const onFinish = (values) => {
        try {
            const payload = {
                tuManx: record?.manx,
                denMakk: values?.denMakk,
                ...values,
                onSuccess: ({ data }) => {
                    if (data.data.Id && data.data.MaPhieu && childRef.current) {
                        childRef.current.signedDocumentCreate(
                            data.data.Id,
                            data.data.MaPhieu
                        );

                        notification.info({ message: "Thông báo", description: `Đã sao chép thành số phiếu <${data.data.MaPhieu}>` })
                    }
                },
            };

            dispatch(copyPhieuNhapThueSangNoiBo(payload));
        } catch (error) { }
    };
    const tableColumns = useMemo(
        () => [
            {
                title: "STT",
                width: 40,
                align: "center",
                dataIndex: "thuTu",
            },
            {
                title: "Mã số",
                width: 80,
                dataIndex: "maview",
                editable: true,
            },
            {
                title: "Tên thuốc, vật tư",
                width: 250,
                dataIndex: "tenhh",
                editable: true,
                render: (txt, record) => (record.tenhh
                ),
            },
            {
                title: "ĐVT",
                dataIndex: "tendonvitinh",
                width: 100,
                editable: true,
                render: (txt, record) => (record.tendonvitinh
                ),
            },
            {
                title: "Số lượng",
                width: 100,
                dataIndex: "soluong",
                align: "right",
                editable: true,
                isMoney: true,
                render: (value) => (value ? Utils.formatterNumber(value) : 0),
            },
            {
                title: "Đơn giá",
                width: 100,
                dataIndex: "dongia",
                align: "right",
                editable: true,
                isMoney: true,
                render: (value) => (value ? Utils.formatterNumber(value) : 0),
            },
            {
                title: "Thành tiền",
                width: 100,
                dataIndex: "thanhtien",
                align: "right",
                editable: true,
                isMoney: true,
                render: (value) => (value ? Utils.formatterNumber(value) : 0),
            },
            {
                title: "Chiết khấu",
                width: 100,
                dataIndex: "chietkhauct",
                editable: true,
                render: (value) => (value ? Utils.formatterNumber(value) : 0),
            },
            {
                title: "Thuế (%)",
                width: 80,
                dataIndex: "thuect",
                editable: true,
                render: (e, r, i) => THUE_SUAT?.find((f) => f.value === e)?.label,
            },
            {
                title: "Tiền thuế",
                width: 70,
                dataIndex: "thanhtienthue",
                align: "right",
                editable: false,
                isMoney: true,
                render: (value) => (value ? Utils.formatterNumber(value) : 0),
            },
            {
                title: "Thành Tiền sau thuế",
                width: 90,
                dataIndex: "thanhtienxuat",
                align: "right",
                editable: false,
                isMoney: true,
                render: (value) => (value ? Utils.formatterNumber(value) : 0),
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [nhapKhoCTList]
    );

    const ChiTiet = () => {
        return <Table dataSource={nhapKhoCTList} columns={tableColumns} pagination={false}
            style={{ padding: "0px" }}
            rowClassName="editable-row"
            tableLayout="fixed"
            scroll={{ x: "max-content" }}
        />
    }

    return (
        <SlipModalComponent
            ref={childRef}
            maskClosable={false}
            bodyStyle={{ overflowY: "auto", maxHeight: "calc(100vh - 300px)" }}
            width={1400}
            title={"Sao chép phiếu nhập từ Thuế sang Nội bộ"}
            widthInfo={550}
            //objectId={importHoadonList?.hoaDonViewModel?.id}
            objectType={"PhieuNhapKho"}
            documentTypeId={DOCUMENT_TYPE_ID.NhapHang}
            titleTLink="Sao chép phiếu nhập từ Thuế sang Nội bộ"
            isVisibleModal={isVisibleCopy}
            onRenderTab={[
                {
                    label: "Thông tin chi tiết",
                    children: (
                        <ChiTiet />
                    ),
                },
            ]}
            onRenderInfo={() => <>
                <div className="p-3">
                    <Row gutter={24}>
                        <Col sm={24}><h4>Từ Số phiếu: {record.sophieu}</h4></Col>
                    </Row>
                    <Row gutter={24}>
                        <Col sm={24}> <h4>Ngày lập: {Utils.formatDate(record.ngay)}</h4></Col>
                    </Row>
                    <Row gutter={24}>
                        <Col sm={24}> <h4>Đơn vị giao: {(record.tenkkgiao)}</h4></Col>
                    </Row>
                    <Row gutter={24}>
                        <Col sm={24}> <h4>Đơn vị nhận: {(record.tenkknhan)}</h4></Col>
                    </Row>
                </div>
                <Form form={form} layout="vertical" onFinish={onFinish} className="p-3">
                    <Row gutter={24}>
                        <Col sm={24}>
                            <Form.Item
                                name="denMakk"
                                label="Đến kho"
                                rules={[
                                    {
                                        required: true,
                                        message: "Vui lòng chọn kho",
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    //filterOption={filterOption}
                                    options={dmKkList?.filter((x) => x.maloai === 1 && x.isthue === false)}
                                    placeholder="Chọn kho nhập"
                                />
                            </Form.Item>
                        </Col>
                    </Row>


                    <Row gutter={24}>
                        <Col sm={24}>
                            <Form.Item name="ghichu" label="Ghi chú">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col sm={24}>
                            <Button type="primary" onClick={() => form.submit()}>Lưu</Button>
                        </Col>
                    </Row>

                </Form></>}
            onCancelModal={() => {
                form.resetFields();
                setIsVisibleCopy(false)
            }}
        />
    );
};
export default ModelCopyPhieuNhap;
